import { Grid, makeStyles, Paper, TextField, Typography, FormControl, Button } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import Cookies from "js-cookie";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { customerModal } from "../../constants";
import { fecthBlacklistCustomer } from "../../../../../Common/API";
import ScanPartyPopupModal from "../../../../../Common/ScanPartyPopupModal";
import { useEffect } from "react";

const useStyles = makeStyles(theme => ({
    pageFooter: {
        marginBottom: '-26px',
        textAlign: 'right',
        right: 0,
        bottom: 0
    },
    validateStyle: {
        color: '#f44336',
        fontSize: '12px',
        fontWeight: '100',
        marginTop: 20
    },
    mandatoryField: {
        color: '#FF304C',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'padding-box',
        paddingRight: '2px'
    },
    paper: {
        background: 'none',
        width: '100%',
        margin: theme.spacing(1, 'auto'),
        boxShadow: 'none'
    },
    accordianExpandedTitle: {
        fontSize: '12px',
        lineHeight: '13px',
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: '600',
        fontFamily: 'Ubuntu, sans-serif',
        letterSpacing: '0px',
        color: '#2B0A3D',
        opacity: 1
    },
    inputField: {
        "&::placeholder": {
            fontSize: '12px',
            lineHeight: '20px',
            fontStyle: 'normal',
            fontVariant: 'normal',
            fontWeight: '400',
            fontFamily: 'Ubuntu, sans-serif',
            letterSpacing: '0px',
            color: '#828282',
            opacity: 1
        },
        marginTop: '13px',
        fontSize: '12px',
        lineHeight: '20px',
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: '400',
        fontFamily: 'Ubuntu, sans-serif',
        letterSpacing: '0px',
        color: '#828282',
        opacity: 1
    },
    cancelButton: {
        fontFamily: 'Ubuntu, sans-serif',
        borderRadius: '30px',
        textTransform: 'none',
        cursor: 'pointer',
        margin: '5px 20px 5px 0',
        '&:hover': {
            backgroundColor: '#FFFFFF',
            textDecoration: 'none'
        }
    },
    applyBtn: {
        fontFamily: 'Ubuntu, sans-serif',
        borderRadius: '30px',
        textTransform: 'none',
        cursor: 'pointer',
        margin: '5px 20px 5px 0',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#0070AD',
            textDecoration: 'none',
            boxShadow: 'none',
            color: '#fff'
        }
    },

    selectBtn: {
        fontFamily: 'sans-serif',
        borderRadius: '30px',
        textTransform: 'none',
        cursor: 'pointer',
        margin: '-20px 20px 15px 0',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#0070AD',
            textDecoration: 'none',
            boxShadow: 'none',
            color: '#fff'
        }
    },
    errorMessge: {
        color: '#af5858',
        fontSize: 16,
        border: 'solid 1px #af5858',
        margin: '26px 0',
        padding: 15
    },
}))

const Exporter = (props) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const userId = localStorage.getItem('userId');
    const [, forceUpdate] = useState();
    const [noOfMatch, setNoOfMatch] = useState("");
    const [matchData, setMatchData] = useState([]);
    const [isBtnDisable, setIsBtnDisable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const formValidator = useRef(new SimpleReactValidator({}));

    useEffect(() => {
        props.setExpCountry(props.countries.find(x => x.ctrycode === props.exporterData.party_country));
    }, [])

    const handleChangeExporter = (field, value) => {
        setIsBtnDisable(false);
        props.setExporterData(values => ({ ...values, [field]: value }));
    }

    const handleCancel = () => {
        navigate('/');
    }

    const handleSaveExporter = () => {
        const isValid = formValidator.current.allValid();
        if (isValid) {
            const payload = { ...customerModal };
            payload.party_name = props.exporterData.party_name;
            payload.contact_email = props.exporterData.contact_email ? props.exporterData.contact_email : '';
            payload.contact_name = props.exporterData.contact_name ? props.exporterData.contact_name : '';
            payload.contact_phone = props.exporterData.contact_phone;
            payload.party_addr1 = props.exporterData.party_addr1 ? props.exporterData.party_addr1 : '';
            payload.party_addr2 = props.exporterData.party_addr2 ? props.exporterData.party_addr2 : '';
            payload.party_city = props.exporterData.party_city ? props.exporterData.party_city : '';
            payload.party_state = props.exporterData.party_state ? props.exporterData.party_state : '';
            payload.party_zipcode = props.exporterData.party_zipcode ? props.exporterData.party_zipcode : '';
            payload.party_vatno = props.exporterData.party_vatno ? props.exporterData.party_vatno : '';
            payload.user = userId;
            payload.ptype = "exp";
            payload.partyid = props.pid;
            payload.invid = props.invoiceId;
            payload.party_country = props.expCountry.ctrycode;
            if (props.addrId === undefined) {
                payload.party_addr_id = 0;
            } else {
                payload.party_addr_id = props.addrId
            }
            props.saveExportAddr(payload);
            setIsBtnDisable(true);
        } else {
            formValidator.current.showMessages();
            forceUpdate(1);
        }
    }

    const handleCountry = (newValue) => {
        setIsBtnDisable(false);
        let newObj = {
            id: newValue.ctrycode,
            ctrycode: newValue.ctrycode,
            ctrycname: newValue.ctrycname
        }
        props.setExpCountry(newObj);
    }

    const handleCheckBlackList = () => {
        setIsPopupOpen(!isPopupOpen);
        getScanDetails();
    }

    const getScanDetails = () => {
        const payload = {
            "search": {
                "securekey": "dMvMAaml7DdsJN7Y0MHcgIrqhB9d5qOb7fAnq",
                "filters": {
                    "fuzzylogic": "false",
                    "dplguruforensic": "false",
                    "sources": "DPLGuru, DPLGuru Demo Portal, JFW, EU Sanctions List",
                    "exclusionwords": "pvt",
                    "redflag": "military"
                },
                "itemstosearch": [
                    {
                        "name": props.exporterData.party_name,
                        "address": "",
                        "country_code": ""
                    }
                ]
            }
        }

        fecthBlacklistCustomer(payload).then(data => {
            setNoOfMatch(data.summary.matches)
            if (data.records.matches === "0") {
                setMatchData([]);
                setIsLoading(false);
            } else {
                setMatchData(data.records);
                setIsLoading(false);
            }
            //const req = { "party_id": props.pid ? props.pid : props.customerId, 'type': 'api', 'matches': data.summary.matches, 'remarks': '', 'user': localStorage.getItem('userId'), statuscode: data.status.statuscode }
            //props.addScanParty(req);
        }).catch(error => {

        })
    }

    const renderExporter = () => {
        return (
            <React.Fragment>
                <Paper component="form" className={classes.paper}>
                    {localStorage.getItem('party_type') !== 'CST' ?
                        <>
                            <Grid container item xs={12} justifyContent="flex-end">
                                <Button variant="contained" color="primary"
                                    className={classes.selectBtn}
                                    onClick={() => handleCheckBlackList()}>
                                    Scan Blacklist Customer
                                </Button>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="party_name">
                                                <span className={classes.mandatoryField}>*</span>
                                                Party Name
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="partyName"
                                            color="primary"
                                            value={props.exporterData?.party_name}
                                            variant="outlined"
                                            onChange={(e) => handleChangeExporter("party_name", e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Party Name"
                                        />
                                        {formValidator.current.message('Party Name', props.exporterData?.party_name, 'required', { className: classes.validateStyle })}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="contact_name">
                                                Contact Name
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="contact"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.contact_name}
                                            onChange={(e) => handleChangeExporter('contact_name', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Contact Name"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="telephone">
                                                <span className={classes.mandatoryField}>*</span>
                                                Telephone
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="telephone"
                                            color="primary"
                                            value={props.exporterData?.contact_phone}
                                            variant="outlined"
                                            onChange={(e) => handleChangeExporter("contact_phone", e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Telephone"
                                        />
                                        {formValidator.current.message('Telephone', props.exporterData?.contact_phone, 'required', { className: classes.validateStyle })}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="email">
                                                Email
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="Email"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.contact_email}
                                            onChange={(e) => handleChangeExporter('contact_email', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Email"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="vat_no">
                                                VAT No.
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="VAT"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.party_vatno}
                                            onChange={(e) => handleChangeExporter('party_vatno', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="VAT No."
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="add1">
                                                Address 1
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="add1"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.party_addr1}
                                            onChange={(e) => handleChangeExporter('party_addr1', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Address 1"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="add2">
                                                Address 2
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="add2"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.party_addr2}
                                            onChange={(e) => handleChangeExporter('party_addr2', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Address 2"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="city">
                                                City
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="city"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.party_city}
                                            onChange={(e) => handleChangeExporter('party_city', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="City"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="state">
                                                State
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="state"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.party_state}
                                            onChange={(e) => handleChangeExporter('party_state', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="State"
                                            inputProps={{ maxLength: 3 }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="zip">
                                                Zip
                                            </label>
                                        </Typography>
                                        <TextField
                                            id="zip"
                                            color="primary"
                                            variant="outlined"
                                            value={props.exporterData?.party_zipcode}
                                            onChange={(e) => handleChangeExporter('party_zipcode', e.target.value)}
                                            className={classes.inputField}
                                            placeholder="Zip"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <Typography className={classes.accordianExpandedTitle}>
                                            <label htmlFor="country">
                                                <span className={classes.mandatoryField}>*</span>
                                                Country
                                            </label>
                                        </Typography>
                                        <Autocomplete
                                            disableClearable
                                            id="country-select"
                                            value={props.expCountry}
                                            options={props.countries}
                                            getOptionLabel={(option) => option.ctrycname}
                                            getOptionSelected={(option, value) => value?.ctrycode === option?.ctrycode}
                                            onChange={(e, newValue) => handleCountry(newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    required
                                                    {...params}
                                                    placeholder="Country"
                                                    variant="outlined"
                                                    margin="normal"
                                                    className={classes.inputField}
                                                />
                                            )}
                                        />
                                        {formValidator.current.message('Country', props.expCountry, 'required', { className: classes.validateStyle })}
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container wrap="wrap" className={classes.pageFooter}>
                                <Grid item xs={12}>
                                    <Button variant="outlined" color="primary"
                                        className={classes.cancelButton}
                                        onClick={() => handleCancel()}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained" color="primary"
                                        className={classes.applyBtn}
                                        disabled={isBtnDisable}
                                        onClick={() => handleSaveExporter()}>
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </> :
                        <Grid container spacing={3}>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="party_name">
                                            Party Name
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="partyName"
                                        color="primary"
                                        value={props.exporterData?.party_name}
                                        variant="outlined"
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Party Name"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="contact_name">
                                            Contact Name
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="contact"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.contact_name}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Contact Name"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="telephone">
                                            Telephone
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="telephone"
                                        color="primary"
                                        value={props.exporterData?.contact_phone}
                                        variant="outlined"
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Telephone"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="email">
                                            Email
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="Email"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.contact_email}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Email"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="vat_no">
                                            VAT No.
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="VAT"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_vatno}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="VAT No."
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="add1">
                                            Address 1
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="add1"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_addr1}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Address 1"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="add2">
                                            Address 2
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="add2"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_addr2}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Address 2"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="city">
                                            City
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="city"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_city}
                                        oInputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="City"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="state">
                                            State
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="state"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_state}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="State"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="zip">
                                            Zip
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="zip"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_zipcode}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Zip"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <Typography className={classes.accordianExpandedTitle}>
                                        <label htmlFor="country">
                                            Country
                                        </label>
                                    </Typography>
                                    <TextField
                                        id="country"
                                        color="primary"
                                        variant="outlined"
                                        value={props.exporterData?.party_country}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        className={classes.inputField}
                                        placeholder="Country"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    }
                </Paper>
            </React.Fragment>
        )
    }

    return (
        <>
            {renderExporter()}
            {isPopupOpen && (
                <ScanPartyPopupModal
                    isPopupOpen={isPopupOpen}
                    setIsPopupOpen={setIsPopupOpen}
                    scanDetails={matchData}
                    isLoading={isLoading}
                    matches={noOfMatch} />
            )}
        </>
    )
}

export default Exporter;